<div class="d-flex justify-content-center align-items-center success-page">
  <div class="d-flex justify-content-center align-items-center">
    <img
      src="assets\images\undraw_certification_re_ifll 1.svg"
      alt="Not Found"
      class="not-found-image"
    />
    <div class="margin-left-m">
      <div class="margin-top-m margin-bottom-m font-size-32">Success</div>
      <div class="font-size-14 margin-bottom-m">
        The submission has been successfully reviewed.
      </div>
      <div class="d-flex align-items-center justify-content-center">
        <dds-button
          class="custom-button margin-right-m"
          [theme]="secondaryButton.theme"
          [kind]="secondaryButton.kind"
          [size]="htmlElementSize"
          [width]="secondaryButton.width"
          [ariaLabel]="secondaryButton.ariaLabel"
          (clicked)="navigateToDashboard()"
          >Return to dashboard</dds-button
        >
        <dds-button
          class="custom-button"
          [theme]="secondaryButton.theme"
          [kind]="secondaryButton.kind"
          [size]="htmlElementSize"
          [width]="secondaryButton.width"
          [ariaLabel]="secondaryButton.ariaLabel"
          (clicked)="navigateToSubmission()"
          >Open submission</dds-button
        >
      </div>
    </div>
  </div>
</div>
